export default __webpack_public_path__ + "static/media/km.2baccf81.jpg";